export const QUESTION_TYPE = {
  SIMPLE: 'simple',
  DETAIL: 'detail',
};

export enum QuestionResponseFormat {
  PLAIN_TEXT = 'PLAIN_TEXT',
  JSON_AST = 'JSON_AST',
}
